export const styles = theme => ({
    bigTopMargin: {
        marginTop: theme.spacing(4)
    },
    aCInputRoot: {
        '&&[class*="MuiOutlinedInput-root"] input': {
            padding: 18
        }
    },
    aCOption: {
        backgroundColor: "white"
    },
    aCListbox: {
        backgroundColor: "white"
    }
});
